import { themeAtom } from "Infrastructure/Theme/Atom/themeAtom";
import { LogoIcon } from "Shared/Assets/Images/Svgs/LogoIcon";
import { styled } from "@mui/material";
import { useAtom } from "jotai";
import { Link } from "react-router-dom";

export function Logo() {
	const [themeConfiguration] = useAtom(themeAtom);
	const toggleWidth = () => {
		if (!themeConfiguration.isCollapse || themeConfiguration.isSidebarHover) {
			return "180px";
		}
		return "80px";
	};
	const LinkStyled = styled(Link)(() => ({
		height: themeConfiguration.TopbarHeight,
		width: toggleWidth(),
		overflow: "hidden",
		display: "block",
	}));

	return (
		<LinkStyled
			to="/"
			style={{
				display: "flex",
				alignItems: "center",
			}}
		>
			<LogoIcon />
		</LinkStyled>
	);
}
